import * as React from "react";
import type { SVGProps } from "react";

const getTheme = (theme) => {
  return theme === "dark" ? "#FFFFFF" : "#121214";
};
const SvgTwoColorReferral = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={16}
    height={16}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#F7A600"
      d="M13.233 14.184a.754.754 0 0 0-.546-.912.746.746 0 0 0-.908.544l-.127.514a2.027 2.027 0 0 0-1.51.24 2.05 2.05 0 0 0-.927 1.262 2.07 2.07 0 0 0 .229 1.554c.278.469.73.808 1.257.942l1.504.38a.54.54 0 0 1 .331.25.564.564 0 0 1-.19.766.534.534 0 0 1-.408.061l-2.256-.571a.746.746 0 0 0-.908.544c-.1.402.145.81.547.912l.877.222-.115.466c-.1.402.145.81.546.912a.746.746 0 0 0 .908-.544l.116-.467c.504.107 1.03.018 1.472-.25a2.05 2.05 0 0 0 .927-1.26 2.07 2.07 0 0 0-.229-1.555 2.047 2.047 0 0 0-1.257-.941l-1.504-.381a.54.54 0 0 1-.331-.249.564.564 0 0 1 .19-.766.534.534 0 0 1 .408-.062l2.256.572a.746.746 0 0 0 .907-.544.754.754 0 0 0-.546-.912l-.84-.213.127-.514ZM18.75 21v-1.75H17a.75.75 0 0 1 0-1.5h1.75V16a.75.75 0 0 1 1.5 0v1.75H22a.75.75 0 0 1 0 1.5h-1.75V21a.75.75 0 0 1-1.5 0Z"
    />
    <path
      fill={getTheme(props["data-theme"])}
      d="M8.75 7a3.25 3.25 0 1 1 6.5 0 3.25 3.25 0 0 1-6.5 0Zm6.168 3.748a4.75 4.75 0 1 0-5.836 0A8.754 8.754 0 0 0 3.25 19v2.5a.75.75 0 0 0 1.5 0V19a7.25 7.25 0 0 1 12.392-5.111.749.749 0 1 0 1.146-.962l.006-.006a8.757 8.757 0 0 0-3.376-2.173Z"
    />
  </svg>
);
export default SvgTwoColorReferral;
